// src/pages/Admin/Business/Finance/charts/UpcomingCommitmentsBar.jsx

import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Line,
  ComposedChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { fmtMoney } from "../financeCommitments.utils";

const UpcomingCommitmentsBar = ({ data = [] }) => {
  if (!data.length) {
    return (
      <div className="grid h-[280px] place-items-center text-sm text-slate-400 dark:text-slate-500">
        Aucune donnée disponible.
      </div>
    );
  }

  return (
    <div className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={data}>
          <CartesianGrid strokeDasharray="3 3" opacity={0.15} />
          <XAxis dataKey="label" />
          <YAxis yAxisId="left" allowDecimals={false} />
          <YAxis yAxisId="right" orientation="right" />
          <Tooltip
            formatter={(value, name) => {
              if (name === "Montant estimé") return [fmtMoney(value), name];
              return [value, name];
            }}
            contentStyle={{
              borderRadius: 16,
              border: "1px solid rgba(148,163,184,0.2)",
            }}
          />
          <Legend />
          <Bar
            yAxisId="left"
            dataKey="count"
            name="Nombre"
            radius={[10, 10, 0, 0]}
            fill="#6366f1"
          />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="amount"
            name="Montant estimé"
            stroke="#ec4899"
            strokeWidth={3}
            dot={{ r: 4 }}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default UpcomingCommitmentsBar;